import { FC, ReactNode } from 'react';
import { ListItem } from '@chakra-ui/react';

import SunshineIcon from 'components/_core/SunshineIcon';
import Text from 'components/_core/Text';

interface UpsellModalListItemProps {
  children: ReactNode;
}

const UpsellModalListItem: FC<UpsellModalListItemProps> = ({ children }) => (
  <Text alignItems="center" as={ListItem} columnGap="space-12" display="flex">
    <SunshineIcon name="tick" size="icon-24" />
    {children}
  </Text>
);

export default UpsellModalListItem;
